import apiClient from '../utils/apiClient';

export const getTranslationUserEndpoint = (role, id = '') => {
  const basePath = role === 'reviewer' ? '/translator/reviewer' : '/translator';
  return id ? `${basePath}/${id}` : basePath;
};

export const fetchTranslationUsers = () => apiClient.get('/translator/all');

export const fetchTranslationUserById = (role, id) => (
  apiClient.get(getTranslationUserEndpoint(role, id))
);

export const createTranslationUser = (role, payload) => (
  apiClient.post(getTranslationUserEndpoint(role), payload)
);

export const updateTranslationUser = (role, id, payload) => (
  apiClient.put(getTranslationUserEndpoint(role, id), payload)
);

export const deleteTranslator = (id) => (
  apiClient.delete(`/translator/${id}`)
);

export const deleteReviewer = (id) => (
  apiClient.delete(`/translator/reviewer/${id}`)
);

export const fetchPreviewToken = (role, language, country) =>
  apiClient.get('/translator/preview-token', { params: { role, language, country } });